export const IconTopAngle = props => (
  <svg width={24} height={24} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M100 0H0v100C0 44.772 44.772 0 100 0Z" fill="current" />
  </svg>
);
